import { Environment } from '@digitalfactorycz/core';

export const environment = new Environment({
  appUrl: process.env?.VUE_APP_FRONTEND_URL || window.location.origin,
  apiUrl: process.env?.VUE_APP_BACKEND_URL || undefined,
  prefix: process.env?.VUE_APP_TRANSLATIONS_PREFIX || undefined,
});
